import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Form, Row } from 'reactstrap'
import { useFormik } from 'formik';
import * as Yup from "yup";
import { CustomDropdown } from 'components/shared/CustomDropdown';
import CommonService from 'services/CommonService';
import { ICategoryModel, ISeriesModel } from 'models/CategoryList.Model';
import { HelperConstant } from '../../helpers/HelperConstant';
import { CustomButton } from 'components/shared/CustomButton';
import FileSaver from 'file-saver';
import { Filesystem, Directory, WriteFileResult } from '@capacitor/filesystem';
import { IDownloadProductReport } from 'models/DownloadProductReport.Model';
import { isPlatform } from '@ionic/react';
import { useNavigate } from 'react-router-dom';
import { IGetVariantModal } from 'models/productvalue.Model';
import { FileOpenerOptions, FileOpener } from '@capacitor-community/file-opener';
import { ScheduleOptions, LocalNotifications } from '@capacitor/local-notifications';


export default function ProductReport() {
    const navigate = useNavigate()
    const [categoryList, setCategoryList] = useState<Array<ICategoryModel>>([]);
    const [ProductList, setProductList] = useState<Array<any>>([]);
    const [brandList, setBrandList] = useState<Array<ICategoryModel>>([]);
    const [seriesModelList, setSeriesModelList] = useState<Array<ISeriesModel>>([]);
    const [categoryId, setCategoryId] = useState<number>(1);
    const [productId, setProductId] = useState<any>();
    const [brandId, setBrandId] = useState<any>();
    const [seriesModelId, setSeriesModelId] = useState<any>();
    const [isDownload, setIsDownload] = useState<boolean>(false);
    const [noRecord, setIsNoRecord] = useState<boolean>(false);

    const validation = useFormik<any>({
        enableReinitialize: true,
        initialValues: {
            categoryId: categoryId,
            gadgetId: "",
            brandId: "",
            modelId: ""
        },
        validationSchema: Yup.object({
            categoryId: Yup.string().notOneOf(['0']).required("Please Select Category"),

        }),
        onSubmit: (values: any) => {
            // downloadReports(values.startDate, values.endDate, values.fileType);
            DownloadInvoice();
        }
    });

    const GetProductCategoryList = () => {
        CommonService.get("master", "GetProductCategory").then(res => {
            if (res.status === 200) {
                setCategoryList(res.data);
                ProductTypeServicesData();
                setCategoryId(res.data[0].Id);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const ProductTypeServicesData = () => {
        CommonService.get("ProductType", "GetList").then(res => {
            if (res.status === 200) {
                setProductList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const GetBrandMasterByProductId = (productTypeId: number) => {
        CommonService.getWithDoubleEntity("master", "GetBrandMasterByProductId", productTypeId, HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setBrandList(res.data);
                setProductId(productTypeId);
                setBrandId(""); 
                setSeriesModelId("");
                setSeriesModelList([]);
                setIsNoRecord(false);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const GetBrands = (BrandId: any, CategoryId: any) => {

        let reqData: IGetVariantModal = {
            offsetStart: null,
            rowsPerPage: null,
            sortOrder: '',
            sortOrderColumn: '',
            searchText: '',
            isPublic: '',
            brandMasterId: BrandId,
            categoryId: CategoryId,
            seriesModelId: ''
        }

        if (BrandId > 0) {
            setSeriesModelList([]);
            // setSeriesModelId(0);
            setBrandId(BrandId);
            CommonService.post("modelvariant", "GetVariants", reqData).then(res => {
                if (res.status === 200) {
                    setSeriesModelList(res.data);
                    setIsNoRecord(false);
                }
                if (res.status === 204) {
                    setIsNoRecord(true);
                }
            }).catch(e => {
                console.log(e);
            });
        }
    }

    const getSeriesModel = (seriesModelId: any) => {
        setSeriesModelId(seriesModelId);
    }

    const screenRefresh = () => {
        window.location.reload();
    }

    // const downloadMobileInvoice = async (file: any) => {
    //     const currentDate = new Date().toLocaleString().replace(/[,:\s]/g, '-');
    //     const path = `DOFY-${currentDate}-Product-Invoice.csv`;
    //     Filesystem.writeFile({
    //         path: path,
    //         data: file,
    //         directory: Directory.Documents,
    //         recursive: true
    //     });
    // }


    const downloadMobileInvoice = async (file: any, path: any) => {
        Filesystem.writeFile({
            path: path,
            data: file,
            directory: Directory.Documents,
            recursive: true
        }).then((res: WriteFileResult) => {
            showInvoiceNotification(res.uri, path);
        }).catch(e => console.log(e));
    };

    const openDownloadedFile = async (uri: any) => {
        try {
            const fileOpenerOptions: FileOpenerOptions = {
                filePath: uri,
                openWithDefault: true,
            };
            await FileOpener.open(fileOpenerOptions);

        } catch (e) {
            console.log('Error opening file', e);
        }
    };

    const showInvoiceNotification = async (uri: any, name: any) => {
        let options: ScheduleOptions = {
            notifications: [
                {
                    id: 2,
                    title: name,
                    body: "Download completed. File saved in Documents",
                    extra: { uri: uri },
                    actionTypeId: "open_pdf"
                }
            ]
        };

        try {
            await LocalNotifications.schedule(options);
        } catch (error) {
            console.log(error);
        }

        LocalNotifications.addListener('localNotificationActionPerformed', async (notification) => {
            if (notification.notification.actionTypeId === 'open_pdf') {
                const uri = notification.notification.extra.uri;
                openDownloadedFile(uri);
            }
        });
    }
    const DownloadInvoice = () => {
        const data: IDownloadProductReport = {
            CategoryId: categoryId,
            ProductTypeId: productId,
            BrandMasterId: brandId,
            SeriesModelId: seriesModelId,
            SortOrder: "",
            SortOrderColumn: ""
        }
        CommonService.post("Sell", "DownloadProductListList", data).then(res => {
            if (res.status === 200) {
                if (isPlatform("android") || isPlatform("ios")) {
                    const currentDate = new Date().toLocaleString().replace(/[,:\s]/g, '-');
                    const path = `DOFY-${currentDate}-Product-Invoice.csv`;
                    downloadMobileInvoice(res.data, path);
                    setIsDownload(true);
                    setTimeout(() => { setIsDownload(false) }, 3000);
                }
                else {
                    const csvContent = atob(res.data);
                    const blob = new Blob([csvContent], { type: "data:application/octet-stream;base64" });
                    const file = new File([blob], `DOFYProductList.csv`, { type: "data:application/octet-stream;base64" });
                    FileSaver.saveAs(file);
                }
            }
        })
    }

    useEffect(() => {
        GetProductCategoryList();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>PRODUCT REPORT</h5>
                    </div>
                    <Card style={{ padding: "20px" }}>
                        <div className=''>
                            {/* <span className={`badge rounded-pill badge-soft-info fw-bolder px-3 pt-2`}>
                                <h5 >Product Inventory List</h5>
                            </span> */}

                            <Form className="form-horizontal"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col lg={6}>
                                        <CustomDropdown
                                            name="categoryId"
                                            label="Category "
                                            id={"categoryId"}
                                            value={validation.values.categoryId || ""}
                                            onChange={(e) => { validation.handleChange(e); setCategoryId(e.target.value); GetBrands(brandId, e.target.value) }}
                                            data={categoryList}
                                            error={validation.errors.categoryId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.categoryId}
                                            invalid={validation.touched.categoryId && validation.errors.categoryId ? true : false}
                                            valueField="Id"
                                            displayField="DisplayName"
                                            isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <CustomDropdown
                                            name="gadgetId"
                                            label="Gadget"
                                            id={"gadgetId"}
                                            value={validation.values.gadgetId || ""}
                                            onChange={(e) => { validation.handleChange(e); GetBrandMasterByProductId(e.target.value) }}
                                            data={ProductList}
                                            error={validation.errors.gadgetId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.gadgetId}
                                            invalid={validation.touched.gadgetId && validation.errors.gadgetId ? true : false}
                                            valueField="Id"
                                            displayField="DisplayName"
                                        // isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <CustomDropdown
                                            name="brandId"
                                            label="Brand"
                                            id={"brandId"}
                                            value={validation.values.brandId || ""}
                                            onChange={(e) => { validation.handleChange(e); GetBrands(e.target.value, categoryId) }}
                                            data={brandList}
                                            error={validation.errors.brandId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.brandId}
                                            invalid={validation.touched.brandId && validation.errors.brandId ? true : false}
                                            valueField="Id"
                                            displayField="DisplayName"
                                        // isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <CustomDropdown
                                            name="modelId"
                                            label="Brand Model"
                                            id={"modelId"}
                                            value={validation.values.modelId || ""}
                                            onChange={(e) => { validation.handleChange(e); getSeriesModel(e.target.value) }}
                                            data={seriesModelList}
                                            error={validation.errors.modelId}
                                            onBlur={validation.handleBlur}
                                            touched={validation.touched.modelId}
                                            invalid={validation.touched.modelId && validation.errors.modelId ? true : false}
                                            valueField="Id"
                                            displayField="Name"
                                        // isMandatory={true}
                                        />
                                    </Col>
                                    <Col lg={12} className='d-flex justify-content-end mt-4'>
                                        <CustomButton
                                            type="button"
                                            btnClassName="ms-2 btn-soft-secondary w-md"
                                            iconClasssName="mdi mdi-close"
                                            name=""
                                            onClick={() => navigate('/homepage')}
                                        />
                                        {/* <CustomButton
                                        type="reset"
                                        btnClassName="ms-2 btn-soft-primary w-md"
                                        iconClasssName=""
                                        name="Reset"
                                    /> */}
                                        <CustomButton
                                            type={"submit"}
                                            btnClassName={"ms-2 btn-success w-md"}
                                            iconClasssName=""
                                            name={"Generate Report"}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Card>

                </Container>
            </div>
        </React.Fragment >
    )
}
